<template>
  <div>
    <div class="pkg-content-export">
      <div style="text-align: right">
        <!-- 返回 -->

        <el-button v-if="checkExportRole()" type="primary" @click="exportHandle"
          >{{ $t('course.coursecomment.export') }}
        </el-button>
        <el-button  @click="tabRemove()" prefix-icon="iconfont icon-Excel_icon"
          >{{ $t('course.coursecomment.back') }}
        </el-button>
        <!-- <div class="el-icon-my-export"></div> -->
      </div>
    </div>
    <br />
    <div class="pkg-search-box">
      <el-form
        class="pkg-content"
        label-position="top"
        label-width="auto"
        :model="topDataForm"
        @keyup.enter.native="getDataList()"
      >
        <el-row class="search-box">
          <el-col :span="24">
            <el-row class="margb10">
              <el-col :span="6">
                <!-- 课程编号 -->
                <el-form-item
                  :label="$t('course.coursecomment.viewCourseCode')"
                  class="search-item"
                  prop="courseCode"
                >
                  <span>{{ topDataForm.courseCode }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="1">
                <el-divider direction="vertical"></el-divider>
              </el-col>
              <!-- 课程名称 -->
              <el-col :span="5">
                <el-form-item
                  :label="$t('course.coursecomment.viewCourseName')"
                  class="search-item"
                  prop="courseName"
                >
                  <span>{{ this.topDataForm.courseName }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="1">
                <el-divider direction="vertical"></el-divider>
              </el-col>
              <el-col :span="5">
                <!-- 平均分 -->
                <el-form-item
                  :label="$t('course.coursecomment.viewAvgScore')"
                  class="search-item"
                  prop="avgScore"
                >
                  <span>{{ this.topDataForm.avgScore.toFixed(1) }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="1">
                <el-divider direction="vertical"></el-divider>
              </el-col>
              <el-col :span="5">
                <!-- 评价总数 -->
                <el-form-item
                  :label="$t('course.coursecomment.viewCommentTotalCount')"
                  class="search-item"
                  prop="commentCount"
                >
                  <span>{{ this.topDataForm.commentCount }}</span>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <br />
    <div class="pkg-search-boxs">
      <el-form
        class="pkg-content"
        label-position="top"
        label-width="auto"
        :model="dataForm"
        @keyup.enter.native="getDataList()"
      >
        <el-row class="search-box" style="padding-bottom: 15px">

            <el-row class="margb10" :gutter="15">
              <el-col :span="7">
                <!-- 用户 -->
                <div class="course-style">
                  <p>用户</p>
                  <el-input
                    v-model="dataForm.userName"
                    placeholder="用户名称"
                  ></el-input>
                </div>
              </el-col>
              <!-- 经销商名称 -->
              <el-col :span="7">
                <div class="course-style">
                  <p>经销商名称</p>
                  <el-input
                    v-model="dataForm.companyName"
                    placeholder="经销商名称"
                  ></el-input>
                </div>
              </el-col>
              <el-col :span="7">
                <!-- 评价时间 -->
                <!-- <el-form-item
                  :label="$t('course.coursecomment.contentTime')"
                  class="search-item"
                > -->
                <div class="course-style">
                  <p>评价时间</p>
                  <el-date-picker
                    v-model="dataForm.contentTime"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    :start-placeholder="
                      $t('course.coursecomment.contentTimePlaceholderStart')
                    "
                    :end-placeholder="
                      $t('course.coursecomment.contentTimePlaceholderEnd')
                    "
                    :clearable="true"
                    style="width: 100%"
                    @change="pickChange"
                  >
                  </el-date-picker>
                </div>
              </el-col>

              <el-col :span="3">
                <el-button
                v-if="checkSelect()"
                  class="btn-query-right"
                  type="primary"
                  @click="getDataListMerge"
                  >{{ $t('course.query') }}
                </el-button>
              </el-col>
            </el-row>

        </el-row>
      </el-form>
    </div>
    <br />
    <div class="pkg-content">
      <div class="table-style" :style="{ 'max-width': 100% + 'px' }">
        <el-table
          class="table-style-x"
          ref="multipleTable"
          v-loading="dataListLoading"
          :data="dataList"
          tooltip-effect="dark"
          border
          :row-style="pointerStyle"
          :cell-style="{ padding: 0 + 'px' }"
        >
          <!--用户-->
          <el-table-column
            prop="userName"
            :label="$t('course.coursecomment.userName')"
            header-align="left"
            align="left"
            min-width="150"
          ></el-table-column>
          <!--经销店名称-->
          <el-table-column
            prop="companyName"
            :label="$t('course.coursecomment.companyName')"
            header-align="left"
            align="left"
            min-width="150"
            show-overflow-tooltip
          ></el-table-column>
          <!--平均分-->
          <el-table-column
            prop="avgScore"
            :label="$t('course.coursecomment.avgScore')"
            header-align="center"
            align="center"
            show-overflow-tooltip
           min-width="150"
          >
          <template slot-scope="scope">
            {{scope.row.avgScore.toFixed(1)}}
          </template>
        </el-table-column>
          <!--实用性-->
          <el-table-column
            prop="practicalScore"
            :label="$t('course.coursecomment.practicalScore')"
            header-align="center"
            align="center"
            show-overflow-tooltip
            min-width="150"
          ></el-table-column>
          <!--趣味性-->
          <el-table-column
            prop="interestScore"
            :label="$t('course.coursecomment.interestScore')"
            header-align="center"
            align="center"
            show-overflow-tooltip
            min-width="150"
          ></el-table-column>
          <!--信息量-->
          <el-table-column
            prop="informationScore"
            :label="$t('course.coursecomment.informationScore')"
            header-align="center"
            align="center"
            show-overflow-tooltip
           min-width="150"
          ></el-table-column>
          <!--评价内容-->
          <el-table-column
            prop="content"
            :label="$t('course.coursecomment.content')"
            header-align="left"
            align="left"
            min-width="150"
            show-overflow-tooltip
          ></el-table-column>
          <!--状态-->
          <el-table-column
            prop="status"
            :label="$t('course.coursecomment.status')"
            header-align="left"
            align="left"
            min-width="120"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <div
                style="
                  display: flex;
                  align-items: center;
                "
              >
                <!--已屏蔽-->
                <span
                  slot="reference"
                  v-show="scope.row.status == 2"
                  style="margin-right: 8px"
                >
                  <em class="dotClass" style="background-color: #ff0c00"></em>
                </span>
                <!--已回复-->
                <span
                  slot="reference"
                  v-show="scope.row.status !== 2 && scope.row.replyCount > 0"
                  style="margin-right: 8px"
                >
                  <em class="dotClass" style="background-color: #07c23a"></em>
                </span>
                <!--未回复-->
                <span
                  slot="reference"
                  v-show="scope.row.status !== 2 && scope.row.replyCount <= 0"
                  style="margin-right: 8px"
                >
                  <em class="dotClass" style="background-color: #ffac00"></em>
                </span>
                {{ statusFormat(scope.row) }}
              </div>
            </template>
          </el-table-column>
          <!--操作 -->
          <el-table-column
            :label="$t('course.coursecomment.operation')"
            fixed="right"
            header-align="center"

            width="130"
          >
            <template slot-scope="scope">
              <div v-if="scope.row.status != 2">
                <div class="reply-style">
                  <!-- 悬浮回复 -->
                  <el-tooltip content="回复" placement="bottom" effect="light">
                    <span
                      v-if="checkReplyRole()"
                      class="el-dropdown-link"
                      @click="dialogReplyOpen(scope.row)"
                      ><img
                        class="picIcon"
                        src="@/assets/img/course/reply@2x.png"
                        alt=""
                      />
                    </span>
                  </el-tooltip>

                  <span style="width: 1px; height: 8px; color: #bebfc1">I</span>
                  <!-- 悬浮屏蔽 -->
                  <el-tooltip content="屏蔽" placement="bottom" effect="light">
                    <span
                      v-if="checkShieldRole()"
                      class="el-dropdown-link"
                      @click="shieldPrompt(scope.row)"
                      ><img
                      class="picIcon"
                        src="@/assets/img/course/shield@2x.png"
                        alt=""
                      />
                    </span>
                  </el-tooltip>
                </div>
              </div>
              <div v-if="scope.row.status == 2||!checkShieldRole()">
                <div class="reply-style">
                  <img
                  class="picIcon"
                    src="@/assets/img/course/reply_block@2x.png"
                    alt=""
                  />
                  <span
                    style="
                      width: 1px;
                      height: 8px;
                      color: rgb(190, 191, 193);
                      margin-top: -1px;
                    "
                    >I</span
                  >
                  <img
                  class="picIcon"
                    src="@/assets/img/course/shield_block@2x.png"
                    alt=""
                  />
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          :current-page="pageNo"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          :total="total"
          layout="total,prev,pager,next,sizes,jumper"
          @size-change="pageSizeChangeHandle"
          @current-change="pageCurrentChangeHandle"
        ></el-pagination>
      </div>

      <reply v-if="dialogReplyVisible" @refresh="refresh" ref="reply"></reply>

      <!--导出-->
      <el-dialog
        :visible.sync="dialogVisible"
        width="431px"
        append-to-body
        :before-close="handleClose"
      >
        <div slot="title">
          <div class="dialog-modl-title-img">
            <img src="@/assets/img/course/Excel_icon.png" alt="" />
          </div>
          <div class="dialog-modl-title">
            {{ $t('course.coursecomment.exportConfirmPrompt') }}
          </div>
        </div>

        <div class="dialog-info">
          {{ this.exportPrompt }}
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">{{
            this.$t('course.coursecomment.cancel')
          }}</el-button>
          <el-button type="primary" @click="downFile">{{
            this.$t('course.coursecomment.confirm')
          }}</el-button>
        </div>
      </el-dialog>
      <!--屏蔽-->
      <!-- <el-dialog
        :visible.sync="dialogShieldVisible"
        width="21%"
        append-to-body
        :before-close="handleShieldClose"
      >
        <div slot="title">
          <div class="dialog-modl-title-img">
            <img src="@/assets/img/course/Icon／Warning.png" alt="" />
          </div>
          <div class="dialog-modl-title">
            {{ $t("course.coursecomment.shieldConfirmPrompt") }}
          </div>
        </div>

        <div class="dialog-shield-info">
          {{ $t("course.coursecomment.shieldPrompt") }}
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogShieldVisible = false">{{
            this.$t("course.coursecomment.cancel")
          }}</el-button>
          <el-button type="primary" @click="doShield">{{
            this.$t("course.coursecomment.confirm")
          }}</el-button>
        </div>
      </el-dialog> -->
      <el-dialog
        :visible.sync="dialogShieldVisible"
        width="21%"
        custom-class="dialogVisibleReurnResource"
      >
        <div class="dialog-modl">
          <div>
            <img src="@/assets/img/course/dialogIcon.png" alt="" />
          </div>
          <div class="dialog-modl-right">
            {{ $t('course.coursecomment.shieldPrompt') }}
          </div>
        </div>

        <span slot="footer" class="dialog-footer">
          <el-button
            @click="dialogShieldVisible = false"
            class="dialog-footer-btn-n"
            >取 消</el-button
          >
          <el-button
            type="primary"
            style="margin-left: 16px"
            @click="doShield"
            class="dialog-footer-btn-y"
            >确 定</el-button
          >
        </span>
      </el-dialog>
      <!-- 返回弹窗 -->
      <el-dialog
        :visible.sync="dialogVisibleReurn"
        width="21%"
        custom-class="dialogVisibleReurnResource"
      >
        <div class="dialog-modl">
          <div>
            <img src="@/assets/img/course/dialogIcon.png" alt="" />
          </div>
          <div class="dialog-modl-right">
            返回上一级别,信息不会保存,确认返回吗？
          </div>
        </div>

        <span slot="footer" class="dialog-footer">
          <el-button
            @click="dialogVisibleReurn = false"
            class="dialog-footer-btn-n"
            >取 消</el-button
          >
          <el-button
            type="primary"
            style="margin-left: 16px"
            @click="tabRemove"
            class="dialog-footer-btn-y"
            >确 定</el-button
          >
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import reply from './reply'

export default {
  components: {
    reply,
  },
  data() {
    let _this = this
    return {
      // 显示查看器

      viewFlag: false,
      dialogVisibleReurn: false,
      imageList: [],
      pageSize: 10,
      pageNo: 1,
      total: 0,
      getDataListURL: '/course/courseComment/listCourseCommentByPage',
      shieldURL: '/course/courseComment/updateCourseCommentStatus',
      exportURL: '/course/commentDetail',
      checkReportIsOKURL: '/course/commonReport/checkReportIsOK',
      // 品牌类型
      // courseBrandArr: _this.enums["courseBrand"],
      courseBrandArr: [],
      //业务团队分类
      // catalogArr: _this.enums["catalogidList1"],
      catalogArr: [],

      teamTypeArr: _this.enums['teamType'],
      createtime: '', // TODO
      dialogReplyVisible: false,
      activatedIsNeed: true, // 此页面是否在激活（进入）时，调用查询数据列表接口？
      topDataForm: {
        courseCode: '',
        courseName: '',
        avgScore: '',
        commentCount: '',
      },
      dataForm: {
        courseId: 0,
        userName: '',
        companyName: '',
        contentTime: '',
        pubDateStart: '',
        pubDateEnd: '',
      },
      dialogReplyDetailVisible: false,
      dataList: [],
      // 等待转圈
      dataListLoading: false,
      dataListAllLoading: false,
      brandQuery: [],
      interval: '',
      dialogVisible: false,
      dialogShieldVisible: false,
      exportInfo: {},
      exportPrompt: '',
      shieldCourseCommentId: '',
    }
  },
  methods: {
    // 按钮权限
    pointerStyle(){
      return {
        cursor: "pointer",
        fontSize: "14px",
        fontFamily: "PingFang SC-Regular, ingFangSC-Regular, sans-serif",
        fontWeight: 400,
        color: "#252628",
        height: "50px",
      };
    },
    // 查询按钮权限
    checkSelect() {
      if (this.$hasPermission('learning:coursecomment:select')) {
        return true
      }
      return false
    },
    //查询
    returnDia() {
      this.dialogVisibleReurn = true
    },
     // 回复完成后刷新列表
     refresh(data){
      if(data){
        console.log("===============")
        this.getDataList()
      }
    },
    getDataList() {
      console.log('123123')
      console.log(this.$route.query.courseId)
      this.$set(this.dataForm, 'courseId', this.$route.query.courseId)

      let courseCommentVO = JSON.parse(JSON.stringify(this.dataForm))
      this.dataListLoading = true
      this.$request
        .post(this.getDataListURL, {
          ps: {
            orderBy: [],
            pageNo: this.pageNo,
            pageSize: this.pageSize,
          },
          courseCommentVO,
        })
        .then((res, total, code, data) => {
          this.dataListLoading = false
          this.dataList = data.data
          this.total = data.totalCount
          console.log(this.dataList,"dataList")
        })
        .catch(() => {
          console.log(' this.$message')
        })
    },
    // 分页, 每页条数
    pageSizeChangeHandle(val) {
      this.pageNo = 1
      this.pageSize = val
      this.getDataList()
    },
    // 分页, 当前页
    pageCurrentChangeHandle(val) {
      this.pageNo = val
      this.getDataList()
    },
    // 查询
    getDataListMerge() {
      this.pageNo = 1
      console.log(this.dataForm.contentTime)
      if (
        this.dataForm.contentTime != null &&
        this.dataForm.contentTime !== ''
      ) {
        this.dataForm.pubDateStart = this.dataForm.contentTime[0]
        this.dataForm.pubDateEnd = this.dataForm.contentTime[1]
      }
      this.getDataList()
    },
    exportHandle() {
      var courseCommentPageVO = {
        companyName: '',
        creatBy: '',
        taskId: '',
        taskStartDate: '',
        taskEndDate: '',
      }

      if (
        this.dataForm.contentTime != null &&
        this.dataForm.contentTime !== ''
      ) {
        this.dataForm.pubDateStart = this.dataForm.contentTime[0]
        this.dataForm.pubDateEnd = this.dataForm.contentTime[1]
      }
      courseCommentPageVO.companyName = this.dataForm.companyName
      courseCommentPageVO.creatBy = this.dataForm.userName
      courseCommentPageVO.taskId = this.dataForm.courseId
      courseCommentPageVO.taskStartDate = this.dataForm.pubDateStart
      courseCommentPageVO.taskEndDate = this.dataForm.pubDateEnd
      this.dataListLoading = true
      this.$request
        .post(this.exportURL, JSON.parse(JSON.stringify(courseCommentPageVO)))
        .thenSingle((data) => {
          // this.dataListLoading = false;
          this.checkReportIsOK(data)
          this.interval = setInterval(() => {
            this.checkReportIsOK(data)
          }, 1000)
        })
        .catch(() => {
          console.log(' this.$message')
        })
    },

    checkReportIsOK(data) {
      this.dataListLoading = true
      this.$request
        .post(this.checkReportIsOKURL + '?reportDownloadId=' + data)
        .thenSingle((data) => {
          if (data.reportStatus == 1) {
            console.log(new Date())
            clearInterval(this.interval)
            this.dataListLoading = false
            this.dialogVisible = true
            this.exportPrompt = '是否下载该报表【' + data.reportName + '】？'
            this.exportInfo = data
            // this.$confirm(
            //   "是否下载该报表【" + data.reportName + "】？",
            //   this.$t("course.coursecomment.exportConfirmPrompt"),
            //   {
            //     confirmButtonText: this.$t("course.coursecomment.confirm"),
            //     cancelButtonText: this.$t("course.coursecomment.cancel"),
            //     iconClass: "iconfont icon-Excel_icon",
            //   }
            // )
            //   .then(() => {
            //     let url = data.downloadUrl;
            //     const down = document.createElement("a");
            //     down.href = url;
            //     // down.download = data.reportName // 下载后文件名
            //     down.style.display = "none";
            //     document.body.appendChild(down);
            //     down.click(); // 点击下载
            //     document.body.removeChild(down); // 下载完成移除元素
            //   })
            //   .catch(() => {});
          } else if (data.reportStatus == 2) {
            // $(".loading-pop").hide();
            console.log(new Date())
            console.log('报表生成出错')
            // promptPop("warning","报表生成出错");
            clearInterval(this.interval)
            this.dataListLoading = false
            this.$message({
              type: 'error',
              message: this.$t('报表生成出错'),
            })
          } else {
            console.log('报表正在创建中...')
            // this.$message({
            //   type: "info",
            //   message: this.$t("报表正在创建中..."),
            // });
          }
        })
        .catch(() => {
          console.log(' this.$message')
        })
    },

    downFile() {
      let url = this.exportInfo.downloadUrl
      const down = document.createElement('a')
      down.href = url
      // down.download = data.reportName // 下载后文件名
      down.style.display = 'none'
      document.body.appendChild(down)
      down.click() // 点击下载
      document.body.removeChild(down) // 下载完成移除元素
      this.dialogVisible = false
    },
    handleClose() {
      this.dialogVisible = false
    },
    handleShieldClose() {
      this.dialogShieldVisible = false
    },
    // 导出
    checkExportRole() {
      if (this.$hasPermission('learning:coursecomment:viewexport')) {
        return true
      }
      return false
    },
    // 回复
    checkReplyRole() {
      if (this.$hasPermission('learning:coursecomment:reply')) {
        return true
      }
      return false
    },
    // 屏蔽
    checkShieldRole() {
      if (this.$hasPermission('learning:coursecomment:shield')) {
        return true
      }
      return false
    },

    // 重置
    again() {
      this.dataList = []
      this.brandQuery = ''
      this.createtime = ''
      ;(this.dataForm = {
        courseName: '', // 课程名称
        trainerName: '', // 课程开发培训师
        creatBy: '', // 创建人
        brandId: '', // 品牌
        courseType: '1',
        teamType: '', // 创建人
        courseStatus: '2',
      }),
        (this.dataListLoading = false)
      this.getDataListMerge()
    },
    // 删除当前页面
    tabRemove() {
      let tabName = this.$store.state.contentTabsActiveName
      if (tabName === 'home') {
        return false
      }
      this.$store.state.contentTabs = this.$store.state.contentTabs.filter(
        (item) => item.name !== tabName
      )
      if (this.$store.state.contentTabs.length <= 0) {
        this.$store.state.sidebarMenuActiveName =
          this.$store.state.contentTabsActiveName = 'home'
        return false
      }
      // 当前选中tab被删除
      if (tabName === this.$store.state.contentTabsActiveName) {
        this.$router.push({
          name: this.$store.state.contentTabs[
            this.$store.state.contentTabs.length - 1
          ].name,
        })
      }
    },
    // 时间清空
    pickChange(value){
      this.dataForm.pubDateStart=value
       this.dataForm.pubDateEnd=value
    },
    //打开回复dialog
    dialogReplyOpen(row) {
      this.dialogReplyVisible = true
      this.$nextTick(() => {
        this.$refs.reply.dialogReplyData = row
        this.$refs.reply.continueFlag = false
        this.$refs.reply.visible = true
      })
    },
    // doShield(row) {
    //   this.$confirm(
    //     this.$t("course.coursecomment.shieldPrompt"),
    //     this.$t("course.coursecomment.shieldConfirmPrompt"),
    //     {
    //       confirmButtonText: this.$t("course.coursecomment.confirm"),
    //       cancelButtonText: this.$t("course.coursecomment.cancel"),
    //       type: "warning",
    //     }
    //   )
    //     .then(() => {
    //       this.dataListLoading = true;
    //       this.isClose = false;
    //       this.$request
    //         .post(
    //           this.shieldURL +
    //             "?courseCommentId=" +
    //             row.courseCommentId +
    //             "&status=2"
    //         )
    //         .then((res, total, code, data) => {
    //           console.log(data);
    //           console.log(2321321312);
    //           this.isClose = true;
    //           this.dataListLoading = false;
    //           if (code == 1) {
    //             this.$message({
    //               type: "success",
    //               message: this.$t("course.coursecomment.shieldSuccess"),
    //             });
    //             this.getDataListMerge();
    //           } else {
    //             this.$message({
    //               type: "success",
    //               message: this.$t("course.coursecomment.shieldFail"),
    //             });
    //           }
    //         })
    //         .catch(() => {
    //           this.dataListLoading = false;
    //           this.isClose = true;
    //           console.log(" this.$message");
    //         });
    //     })
    //     .catch(() => {});
    // },

    shieldPrompt(row) {
      this.dialogShieldVisible = true
      this.shieldCourseCommentId = row.courseCommentId
    },
    doShield() {
      this.dataListLoading = true
      this.$request
        .post(
          this.shieldURL +
            '?courseCommentId=' +
            this.shieldCourseCommentId +
            '&status=2'
        )
        .then((res, total, code, data) => {
          console.log(data)
          console.log(2321321312)
          this.dataListLoading = false
          this.dialogShieldVisible = false
          if (code == 1) {
            this.$message({
              type: 'success',
              message: this.$t('course.coursecomment.shieldSuccess'),
            })
            this.getDataListMerge()
          } else {
            this.$message({
              type: 'success',
              message: this.$t('course.coursecomment.shieldFail'),
            })
          }
        })
        .catch(() => {
          this.dataListLoading = false
          this.dialogShieldVisible = false
          console.log(' this.$message')
        })
    },
    fmtUser(row, column, cellValue) {
      return row.courseCreatRealName + '(' + row.courseCreatBy + ')'
    },
    statusFormat(obj) {
      console.log('状态值:' + obj)
      var statusDesc = '未回复'
      if (obj.status == 2) {
        statusDesc = '已屏蔽'
      } else {
        if (obj.replyCount > 0) {
          statusDesc = '已回复'
        }
      }
      return statusDesc
    },
    fmtDate(row, column, cellValue) {
      cellValue = typeof cellValue == 'number' ? cellValue : Number(cellValue)
      var time = new Date(cellValue)
      return `${time.getFullYear()}-${
        time.getMonth() + 1 >= 10
          ? time.getMonth() + 1
          : '0' + (time.getMonth() + 1)
      }-${time.getDate() >= 10 ? time.getDate() : '0' + time.getDate()} ${
        time.getHours() >= 10 ? time.getHours() : '0' + time.getHours()
      }:${
        time.getMinutes() >= 10 ? time.getMinutes() : '0' + time.getMinutes()
      }:${
        time.getSeconds() >= 10 ? time.getSeconds() : '0' + time.getSeconds()
      }`
    },
  },
  created() {
 // 强制渲染组件
     this.$forceUpdate()
     this.topDataForm =JSON.parse(this.$route.query.listRow)
     console.log(this.topDataForm,"==========")
    this.getDataListMerge()

  },
  watch: {
 '$route' (to, from) {

 if(to){

  this.getDataListMerge()
 }

 }
  }
}
</script>
<style lang="scss" scoped>
@import '../../../../css/pkg-styles.css';
// @import '../../../../../assets/scss/modules/trainingCharge.scss';

.search-item {
  width: 94% !important;
  /*min-width: 290px;*/
}


.pkg-content-export {
  background-color: #fff;
  padding: 10px;
}
.el-table__body-wrapper{
    overflow-x: auto!important;
}
.dotClass {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  display: block;
}
 .el-button {
    font-family: PingFangSC-Regular, sans-serif;
    border-radius: 4px !important;
    padding: 8px 24px !important;
    font-weight: 400 !important;
  }
.dialog-modl-title-img {
  width: 80px;
  height: 0px;
  position: relative;
  top: 20px;
  left: 0px;
}
  // 表头加粗
  .el-table th .cell {
font-size: 14px;
font-family: PingFangSC-Medium, PingFang SC, sans-serif;
font-weight: 550;
color: #252628;
line-height: 20px;
  }
.dialog-modl-title {
  padding-top: 0px !important;
  width: 80px;
  height: 30px;
  position: relative;
  top: 23px;
  left: 30px;
  font-size: 16px;
  font-weight: 600;
  color: #252628;
}
.dialog-info {
  width: 230px;
  line-height: 25px;
  padding-left: 30px !important;
  align-content: left;
  word-break: break-all !important;
  color: rgb(8, 8, 8);

  font-size: 14px;
  font-weight: 400;
}
.btn-query-right {
  float: right;
  margin-top: 8px;
  margin-right: -9px;
}
.dialog-shield-info {
  width: 260px;
  line-height: 25px;
  padding-left: 30px !important;
  align-content: left;
  word-break: break-all !important;
  color: rgb(8, 8, 8);
  font-size: 14px;
  font-weight: 400;
  font-family: PingFangSC-Regular, PingFang SC, sans-serif;
}

.el-divider {
  display: inline-block;
  width: 1px;
  height: 4em;
  margin: 0 8px;
  vertical-align: middle;
  position: relative;
  background-color: #dcdfe6;
}
.course-style {
  display: flex;
  white-space: nowrap;
  justify-content: center;
  text-align: center;
  align-items: center;
  column-gap: 5px;

}
.el-pagination {
  display: flex;
  float: right;
  padding: 8px 3px 21px 0;
  .el-pagination__jump {
    margin-left: 1px !important;
  }
  .el-pager {
    display: flex;
    flex-direction: row;
    column-gap: 9px;
    .number.active {
      color: #ffffff !important;
      background: #1c69d4ff !important;
      border-radius: 2px !important;
    }
    .number {
      width: 30px;
      height: 29px;
      background: #ffffff;
      border-radius: 2px;
      border: 1px solid #dfe0e2;
    }
  }
  .btn-prev {
    height: 29px;
    background: #ffffff;
    border-radius: 1px;
    border: 1px solid #dfe0e2;
    margin-right: 10px;
    margin-left: 7px;
  }
  .btn-next {
    height: 29px;
    background: #ffffff;
    border-radius: 1px;
    border: 1px solid #dfe0e2;
    margin-right: 4px;
    margin-left: 10px;
  }
}

.el-input__inner {
  border-radius: 4px !important;
}
.pkg-content {
  background-color: #fff;
  padding: 20px 20px 0 20px;
}
.el-range-input {
  background-color: white;
  font-size: 12px;
  width: 100%;
}
.el-table__fixed-right {
  width: 140px !important;
  height: 98% !important;
}
::-webkit-scrollbar {
  width: 7px;
  margin-bottom: 8px;
  height: 8px;
  background-color: #f5f5f5 !important;
}
/*定义滚动条轨道 内阴影+圆角*/
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  background-color: #f5f5f5;
}
/*定义滑块 内阴影+圆角*/
 ::-webkit-scrollbar-thumb {
  border-radius: 10px;
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
  background-color: #c8c8c8;
}
.table-style {
  overflow-x: hidden;
}
.reply-style {
  display: flex;
  flex-direction: row;
  column-gap: 9px;
  justify-content: center;
}
.dialog-modl {
  height: 19px;
  display: flex;
  align-content: center;

  img {
    width: 24px;
    height: 24px;
    margin-right: 8px;
    margin-left: 9px;
    margin-top: -18px;
  }
  .dialog-modl-right {
    width: 280px;
    height: 24px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC, sans-serif;
    font-weight: 400;
    color: #252628;
    line-height: 24px;
    margin-top: -11px;
  }
}
.dialog-footer {
  // padding-right: 30px;
    margin: 10px;
    padding-bottom: 20px !important;
    padding-top: 0px !important;
  .dialog-footer-btn {
    margin-bottom: 28px;
    font-family: PingFangSC-Regular, PingFang SC, sans-serif;
  }
}
// 返回弹窗样式

</style>

<style lang="scss">
/* 悬浮按钮样式 */

.el-tooltip__popper {
  border: none !important;
  box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.05),
    0px 6px 16px 0px rgba(0, 0, 0, 0.08);
}

.el-tooltip__popper[x-placement^='top'].popper__arrow::after {
  border-top-color: red !important;
}

.el-tooltip__popper[x-placement^='top'].popper__arrow {
  border-top-color: red !important;
}
 /* 表单头部颜色更改 */
.aui-wrapper .el-table th {
  background: #fafbff!important;
  border-right: 1px #dcdee3 solid
}
.pkg-content-export {
  .el-table {
    tr th, tr td {
      border-right: none !important;
    }
  }
}
.dialogVisibleReurnResource {
  width: 360px!important;
  height: 136px!important;
  background: #ffffff;
  box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.05),
    0px 6px 16px 0px rgba(0, 0, 0, 0.08), 0px 3px 6px -4px rgba(0, 0, 0, 0.12);
  border-radius: 4px;
  .dialog-footer-btn-n {
    font-family: PingFangSC-Regular, PingFang SC, sans-serif;
    font-weight: 400 !important;
    color: #5a5e66;
  }
  .dialog-footer-btn-y {
    font-family: PingFangSC-Medium, PingFang SC, sans-serif;
    font-weight: 500 !important;
    color: #ffffff;
  }
  .el-dialog__headerbtn {
    position: absolute;
    top: 6px;
    right: 9px;
    padding: 0;
    background: 0 0;
    border: none;
    outline: 0;
    cursor: pointer;
    font-size: 16px;
  }
  .el-dialog__body {
    padding: 30px 20px;
    margin-top: -12px;
  }
  .el-dialog__footer {
    border: 0px !important;
    margin-top: -11px;
    margin-right: 0px;
  }
  .dialog-modl {
    height: 19px;
    display: flex;
    align-content: center;

    img {
      width: 24px;
      height: 24px;
      margin-right: 8px;
      margin-left: 9px;
      margin-top: -18px;
    }
    .dialog-modl-right {
      width: 280px;
      height: 24px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC, sans-serif;
      font-weight: 400;
      color: #252628;
      line-height: 24px;
      margin-top: -11px;
    }
  }
}
.picIcon{
  cursor: pointer;
  width: 20px!important;
  height: 21px;
}
</style>
